<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p> </p>
<p class="Epigram ParaOverride-1"><span class="CharOverride-11">Men make their own history, but they do not make it just as they <br/>please; they do not make it under circumstances chosen by <br/>themselves, but under circumstances directly encountered, given <br/>and transmitted from the past.</span></p>
<p class="Text-body-after-subhead ParaOverride-3"><span class="Text-body CharOverride-10">—Karl </span><span class="attribution _idGenCharOverride-1">Marx</span><span class="Text-body CharOverride-10">, </span><span class="Text-body CharOverride-12">The Eighteenth Brumaire of Louis Bonaparte</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi2.vue?d6df17b2